import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, Linkedin } from 'lucide-react';
import { PHONE_NUMBER, EMAIL_ADDRESS, RERA_NUMBER, WHATSAPP_NUMBER } from '../../utils/constants';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer__top">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/logo.png" alt="Smart Property Solutions" />
            </div>
            <p className="footer__desc">
              Premium real estate services across Delhi NCR, Dholera SIR, and Ahmedabad. Building the future. Delivering smart investments.
            </p>
            {/* <p className="footer__rera">RERA Reg: {RERA_NUMBER}</p> */}
            <div className="footer__social">
              <a href="https://instagram.com" aria-label="Instagram"><Instagram size={16}/></a>
              <a href="https://facebook.com" aria-label="Facebook"><Facebook size={16}/></a>
              <a href="https://youtube.com" aria-label="YouTube"><Youtube size={16}/></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><Linkedin size={16}/></a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/properties">Properties</Link></li>
              <li><Link to="/partnership">Channel Partnership</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Our Cities</h4>
            <ul>
              <li><Link to="/cities/delhi-ncr">Delhi NCR</Link></li>
              <li><Link to="/cities/dholera-sir">Dholera SIR</Link></li>
              <li><Link to="/cities/ahmedabad">Ahmedabad</Link></li>
            </ul>
            <h4 style={{marginTop: '24px'}}>Property Types</h4>
            <ul>
              <li><Link to="/properties?type=Apartment">Apartments</Link></li>
              <li><Link to="/properties?type=Commercial">Commercial</Link></li>
              <li><Link to="/properties?type=Plot">Plots</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Contact Us</h4>
            <ul className="footer__contact-list">
              <li><Phone size={14}/><a href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</a></li>
              <li><Mail size={14}/><a href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</a></li>
              <li><MapPin size={14}/><span>H-32, Office No. 304, Sector 63, Noida</span></li>
            </ul>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hello,%20I'm%20interested%20in%20a%20property.%20Please%20share%20details.`}
              className="footer__whatsapp"
              target="_blank" rel="noreferrer"
            >
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" width="16"/>
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="footer__bottom">
      <div className="container">
        <p>© {new Date().getFullYear()} Smart Property Solutions. All rights reserved.</p>
        <div className="footer__bottom-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
